import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import upperFirst from 'lodash/upperFirst';

const withToggle = (key = '', initialValue = false) => {
  const prefixWithKey = param => (key ? key + upperFirst(param) : param);
  const toggle = prefixWithKey('toggle');
  return compose(
    withState(prefixWithKey('isOn'), toggle, initialValue),
    withHandlers({
      [prefixWithKey('on')]: props => (e) => {
        if (e && e.stopPropagation) {
          e.stopPropagation();
        }

        props[toggle](true);
      },
      [prefixWithKey('off')]: props => (e) => {
        if (e && e.stopPropagation) {
          e.stopPropagation();
        }

        props[toggle](false);
      },
      [toggle]: props => () => props[toggle](current => !current),
    })
  );
};

export default withToggle;
